var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tooltip', ("tooltip-" + _vm.position)]},[_c('span',{staticClass:"iAmText"},[_vm._v(_vm._s(_vm.toolTipText))])])}
var staticRenderFns = []

export { render, staticRenderFns }